export const headerNavClasses = {
  root: 'DinoHeaderNav-root',
  mobileMode: 'DinoHeaderNav-mobile-mode'
}

export const exploreClasses = {
  root: 'DinoExplore-root'
}
